<template>
<v-flex xs10 offset-xs1>
  <div class='fl hf mb-5' style='align-items: flex-end;'>
    <div class='golden-left'>
      <h1 class='mb-4'>{{ 'work-stock.overview.title' | translate }}</h1>
      <p>{{ 'work-stock.overview.text' | translate }}</p>
    </div>
    <div class='golden-right fl' style='position: relative; top: -28px;'>
    </div>
  </div>

 <div class='mb-5 filters-container'>
    <v-flex xs10 offset-xs1>
      <div class='hf aic fl'>
        <text-field :placeholder="$t('input.placeholders.which-work-stock-item-are-you-looking-for')" class='mr-4' v-model="search" style="width: 55%">
          <v-icon slot="left">search</v-icon>
        </text-field>

        <work-stock-status isButton v-on:click.native="newStatusFilter = !newStatusFilter" :disabled="!newStatusFilter" style='position: relative; top: 1px;' :status="workStockItemStates.New" class='mr-3' />
        <work-stock-status isButton v-on:click.native="reviewingStatusFilter = !reviewingStatusFilter" :disabled="!reviewingStatusFilter" style='position: relative; top: 1px;' :status="workStockItemStates.Reviewing" class='mr-3' />
        <work-stock-status isButton v-on:click.native="closedStatusFilter = !closedStatusFilter" :disabled="!closedStatusFilter" style='position: relative; top: 1px;' :status="workStockItemStates.Closed" class='mr-4' />

        <date-picker clearable v-model="fromDate" style='width: 25%' class='mr-3' :min="minDate" :max="filterMaxDateForMinDate"/>
        <date-picker clearable v-model="untilDate" style='width: 25%' class='mr-4' :min="filterMinDateForMaxDate" :max="maxDate" right/>
      </div>
    </v-flex>
  </div>

  <div>
    <v-data-table
      :headers="headers"
      :items="filteredWorkStock"
      :loading="isWorkStockLoading"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="[5, 10, 25, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
      rows-per-page-text='Rijen per pagina'>
      <v-progress-linear slot='progress' color='#cdd2dc' indeterminate></v-progress-linear>
      <template slot='items' slot-scope='props'>
        <tr @click="handleOpenWorkStockItem(props.item)" style="cursor: pointer;">
          <td>{{ formatDate(props.item.createdOn) }}</td>
          <td>{{ props.item.employerName }}</td>
          <td>{{ props.item.employeeName }}</td>
          <td>
            <work-stock-status :status="props.item.status" style='left: -8px' />
          </td>
          <td align='right'>{{ getReasonForItem(props.item.reason) }}</td>
          <td style='display: none'>{{ props.item.search }}</td>
        </tr>
      </template>

      <div class='no-results-badge' slot='no-results'>
        <v-icon>warning</v-icon>
        <p>{{ 'errors.no-results-found' | translate }}
          <span>{{ search }}</span>.
        </p>
      </div>

      <div class="no-results-badge" slot="no-data">
        <p>{{ 'errors.no-data-found' | translate }}</p>
      </div>
    </v-data-table>
  </div>
</v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import Helpers from '@/shared/helpers/functions';
import WorkStock from '@/resources/constants/work-stock';
import WorkStockView from '@/views/constants/work-stock';

import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';

import WorkStockStatus from '@/views/components/work-stock/WorkStockStatus.vue';
import { WorkStockItemStates } from '@/resources/models/work-stock-item';

export default {
  name: 'WorkStockIndex',
  components: {
    TextField,
    WorkStockStatus,
    DatePicker
  },
  mounted () {
    this.$store.dispatch(WorkStock.Actions.LoadAll.START);
  },
  data () {
    return {
      headers: [
        { text: 'Aangemaakt Op', value: 'createdOn' },
        { text: 'Werkgever', value: 'employerName' },
        { text: 'Werknemer', value: 'employeeName' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Reden', value: 'reason', align: 'right' },
        { text: '', value: 'search', width: '0px' }
      ],
      workStockItemStates: WorkStockItemStates
    };
  },
  computed: {
    ...mapGetters({
      workStock: 'workStock',
      isWorkStockLoading: 'isWorkStockLoading',
      employees: 'employees',
      employers: 'employers',
      filters: 'workStockIndexFilters'
    }),
    filterMinDateForMaxDate () {
      if (this.fromDate != null && new Date(this.fromDate) > new Date(this.minDate)) {
        return this.fromDate;
      } else {
        return this.minDate;
      }
    },
    filterMaxDateForMinDate () {
      if (this.untilDate != null && new Date(this.untilDate) <= new Date(this.maxDate)) {
        return this.untilDate;
      } else {
        return this.maxDate;
      }
    },
    filteredWorkStock () {
      let result = [];
      if (this.workStock != null) {
        this.workStock.forEach(w => {
          if (new Date(w.createdOn) >= new Date(this.minDate)) {
            if (this.fromDate == null || (this.fromDate != null && new Date(w.createdOn) >= new Date(this.fromDate))) {
              if (this.untilDate == null || (this.untilDate != null && new Date(w.createdOn) <= new Date(this.untilDate))) {
                // to-do add filter
                if ((this.newStatusFilter && w.status === WorkStockItemStates.New) || (this.reviewingStatusFilter && w.status === WorkStockItemStates.Reviewing) || (this.closedStatusFilter && w.status === WorkStockItemStates.Closed)) {
                  let newItem = Object.assign({}, w);

                  const employer = this.employers.find(e => e.customerNumber === w.employerCustomerNumber);
                  if (employer != null) {
                    newItem.employerName = `${employer.tradeName} (${employer.customerNumber})`;
                  } else {
                    newItem.employerName = w.employerCustomerNumber;
                  }

                  newItem.employeeName = w.employeeCustomerNumber;

                  let search = '';
                  search += w.createdOn;
                  search += this.formatDate(w.createdOn);
                  search += this.searchDates(w.createdOn);
                  search += w.employerName;
                  search += w.employeeName;
                  search += w.reason;
                  search += this.$t('work-stock.states.' + w.status);
                  search += w.treatedBy;
                  newItem.search = search;

                  result.push(newItem);
                }
              }
            }
          }
        });
      }
      return result;
    },
    fromDate: {
      get () { return this.filters.fromDate; },
      set (v) { this.changeFilter('fromDate', v); }
    },
    untilDate: {
      get () { return this.filters.untilDate; },
      set (v) { this.changeFilter('untilDate', v); }
    },
    minDate: {
      get () { return this.filters.minDate; },
      set (v) { this.changeFilter('minDate', v); }
    },
    maxDate: {
      get () { return this.filters.maxDate; },
      set (v) { this.changeFilter('maxDate', v); }
    },
    newStatusFilter: {
      get () { return this.filters.newStatusFilter; },
      set (v) { this.changeFilter('newStatusFilter', v); }
    },
    reviewingStatusFilter: {
      get () { return this.filters.reviewingStatusFilter; },
      set (v) { this.changeFilter('reviewingStatusFilter', v); }
    },
    closedStatusFilter: {
      get () { return this.filters.closedStatusFilter; },
      set (v) { this.changeFilter('closedStatusFilter', v); }
    },
    search: {
      get () { return this.filters.search; },
      set (v) { this.changeFilter('search', v); }
    },
    pagination: {
      get () { return this.filters.pagination; },
      set (v) { this.changeFilter('pagination', v); }
    }
  },
  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    searchDates: (date) => Helpers.Dates.searchDates(date),
    handleOpenWorkStockItem (item) {
      this.$store.dispatch(WorkStockView.Actions.Tabs.OPEN_DETAILS, item);
    },
    getReasonForItem (reason) {
      if (/Aanpassen nieuwe ziekmelding/.test(reason) || /Aanpassing nieuwe ziekmelding/.test(reason)) {
        return 'Aanpassing Verwerkte Verzuimmelding.';
      } else if (reason.length > 55) {
        return reason.substr(0, 55) + ' ..';
      } else return reason;
    },
    changeFilter (filter, value) {
      this.$store.dispatch(WorkStockView.Actions.CHANGE_INDEX_FILTER, { filter: filter, value: value });
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.work-stock-item-status {
  padding: 4px 10px 6px 8px;
  border-radius: $border-radius;
  background-color: white;
  font-weight: 600;

  &.new {
    background-color: $positive-lighten-3;
    color: $positive;
  }

  &.in-progress {
    background-color: $secondary-lighten-3;
    color: $secondary;
  }

  &.completed {
    background-color: $gray-lighten-3;
    color: $primary;
  }
}

</style>
